import React from "react";

import InputLabel from "@mui/material/InputLabel";
import Select, { SelectProps } from "@mui/material/Select";
import FormControl, { FormControlProps } from "@mui/material/FormControl";

interface IProps extends SelectProps {
  size?: FormControlProps["size"];
  fullWidth?: boolean;
}

export const MUISelect: React.FC<any> = React.forwardRef<any, IProps>((props, ref) => (
  <FormControl
    size={props.size}
    variant={props.variant}
    sx={props.fullWidth ? { width: '100%' } : { minWidth: 300 }}
    disabled={props.disabled}
    fullWidth={props.fullWidth}
  >
    <InputLabel id={props.id}>{props.label}</InputLabel>
    <Select
      ref={ref}
      id={props.id}
      value={props.value}
      variant={props.variant}
      onChange={props.onChange}
      disabled={props.disabled}
    >
      {props.children}
    </Select>
  </FormControl>
));

MUISelect.defaultProps = {
  variant: "filled",
  size: "small",
};
